export default __webpack_public_path__ + "static/Entenda0090-a4e3b00176dd2305eef7d2d3c38d51bd.jpg";